import React from "react";
import Category from "../components/Category";
import Hero from "../components/Hero";

function Home() {
  return (
    <div>
      <Hero />
      <Category />
      {/* <Newsletter /> */}
    </div>
  );
}

export default Home;
